<template>
  <div class="prize-section">
    <div class="prize-section__section">
      <div class="prize-section__title">
        <SubTitle title="Денежный подарок" :uppercase="true" />
      </div>
      <div class="prize-section__container">
        <div class="prize-section__container_cards">
          <PrizeCard v-for="item in money" :key="item.id" :title="item.name" :image="item.picture" />
        </div>
        <div class="prize-section__container_text">
          <div>Можно перевести накопленные бонусы в денежный эквивалент</div>
          <div><span>1 бонус = 1 рубль</span></div>
          <div>Сертификат на площадки партнеров: OZON, Lamoda, Детский мир</div>
        </div>
        <div class="prize-section__container_mobile">
          <div class="prize-section__container_mobile_block">
            <div>Можно перевести накопленные бонусы в денежный эквивалент</div>
            <div>Сертификат на площадки партнеров: OZON, Lamoda, Детский мир</div>
          </div>
          <div><span>1 бонус = 1 рубль</span></div>
        </div>
      </div>
    </div>
    <!-- <div class="prize-section__section">
      <div class="prize-section__title">
        <SubTitle title="Печатная продукция и оформление точек" :uppercase="true" />
      </div>
      <SwiperCard v-if="printedProducts.length > 0" :cards="printedProducts" />
    </div> -->
    <div class="prize-section__section">
      <div class="prize-section__title">
        <SubTitle title="Брендированная одежда и сувенирная продукция" :uppercase="true" />
      </div>
      <SwiperCard v-if="souvenirs.length > 0" :cards="souvenirs" />
      <div class="prize-section__disclaimer">*Внешний вид товаров может отличаться от изображенных на Сайте</div>
    </div>
  </div>
</template>

<script>
import PrizeCard from "@/components/ui/Cards/PrizeCard.vue";
import SwiperCard from "@/components/ui/Swiper/SwiperCard.vue";
import SubTitle from "@/components/ui/Title/SubTitle.vue";

export default {
  name: "PrizeSection",
  components: {
    SubTitle,
    PrizeCard,
    SwiperCard,
  },
  computed: {
    gifts() {
      return this.$store.getters["content/GET_GIFTS"];
    },
    money() {
      let money = [];
      if (this.gifts) {
        this.gifts.forEach((group) => {
          if (group.code === "money") {
            money = group.items;
          }
        });
      }
      return money;
    },
    printedProducts() {
      let printedProducts = [];
      if (this.gifts) {
        this.gifts.forEach((group) => {
          if (group.code === "printed_products") {
            printedProducts = group.items;
          }
        });
      }
      return printedProducts;
    },
    souvenirs() {
      let souvenirs = [];
      if (this.gifts) {
        this.gifts.forEach((group) => {
          if (group.code === "clothes_souvenirs") {
            souvenirs = group.items;
          }
        });
      }
      return souvenirs;
    },
  },
};
</script>

<style lang="scss" scoped>
.prize-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 120px;

  &__title {
    padding-bottom: 60px;
  }

  &__container {
    display: flex;
    gap: 36px;

    &_cards {
      display: flex;
      gap: 36px;
    }

    &_text {
      max-width: 440px;
      width: 100%;
      @include font("CeraPro", 22px, 500);
      display: flex;
      flex-direction: column;
      gap: 34px;

      & span {
        @include font("CeraPro", 30px, 400);
      }
    }

    &_mobile {
      display: none;
      @include font("CeraPro", 18px, 500);

      & span {
        @include font("CeraPro", 26px, 400);
      }
    }
  }
}

@media screen and (max-width: 930px) {
  .prize-section {
    &__container {
      flex-direction: column;
      gap: 16px;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }

      &_text {
        display: none;
      }

      &_mobile {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;

        &_block {
          display: flex;
          gap: 36px;

          & div {
            width: 284px;
            flex-shrink: 0;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .prize-section {
    gap: 60px;

    &__title {
      padding-bottom: 36px;
    }
  }
}
</style>
